
    // Ensure the exports object is marked as a module
    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    // Import the submodule (or the file you want to export from)
    var _module = require('../dist/svg-components/IconAlertCircleFillExtraSmall.js');

    // Export the default export, if present
    if (_module.default) {
      Object.defineProperty(exports, 'default', {
        enumerable: true,
        value: _module.default
      });
    }

    // Export all named exports, except for the "default" and "__esModule" keys
    Object.keys(_module).forEach(function (key) {
      if (key === 'default' || key === '__esModule') return;
      Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
          return _module[key];
        }
      });
    });
  